"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientInstance = void 0;
var axios_1 = __importDefault(require("../../externals/axios"));
var interfaces_1 = require("./interfaces");
var HttpClient = /** @class */ (function () {
    function HttpClient() {
        // #region Properties (1)
        this._cache = {};
        this.MAX_RETRIES = 3;
        this.counter_retries = 0;
        // #endregion Private Methods (1)
    }
    Object.defineProperty(HttpClient.prototype, "responseType", {
        // #endregion Properties (1)
        // #region Public Accessors (1)
        /**
         * Gets the response type
         * @typeof ResponseType
         */
        get: function () {
            return interfaces_1.ResponseType;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion Public Accessors (1)
    // #region Public Methods (2)
    /**
    * Gets the cached entry async
    * @param { string }url
    * @param { IHttpRequestOptions } options
    * @return { Promise<T> }
    */
    HttpClient.prototype.getAsync = function (url, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = {
                    method: 'GET',
                    url: url
                };
                if (options.timeout) {
                    req.timeout = options.timeout;
                }
                if (options.responseType) {
                    req.responseType = options.responseType;
                }
                if (options.headers) {
                    req.headers = options.headers;
                }
                return [2 /*return*/, this.request(req)];
            });
        });
    };
    /**
     * Gets the cached entry async
     * @param { string }url
     * @param { IHttpRequestOptions } options
     * @return { Promise<T> }
     */
    HttpClient.prototype.getCacheAsync = function (url, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                if (!this._cache[url]) {
                    req = {
                        method: 'GET',
                        url: url
                    };
                    if (options.timeout) {
                        req.timeout = options.timeout;
                    }
                    if (options.responseType) {
                        req.responseType = options.responseType;
                    }
                    this._cache[url] = this.request(req);
                }
                return [2 /*return*/, this._cache[url]];
            });
        });
    };
    // #endregion Public Methods (2)
    // #region Private Methods (1)
    HttpClient.prototype.request = function (req, retry) {
        if (retry === void 0) { retry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (retry === false)
                            this.counter_retries = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default(req)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        if ((error_1.response &&
                            error_1.response.status &&
                            error_1.response.status === 502) ||
                            error_1.request) {
                            this.counter_retries++;
                            if (this.counter_retries <= this.MAX_RETRIES)
                                return [2 /*return*/, this.request(req, true)];
                        }
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return HttpClient;
}());
exports.HttpClientInstance = new HttpClient();
